import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.map";
import "core-js/modules/es6.weak-map";
import _classCallCheck from "/codebuild/output/src3605708562/src/www-public/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3605708562/src/www-public/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/codebuild/output/src3605708562/src/www-public/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.reflect.get";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { classMatchesRegex, IGNORED_NODE, isShadowRoot } from '../../rrweb-snapshot/es/rrweb-snapshot.js';

function on(type, fn) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  var options = {
    capture: true,
    passive: true
  };
  target.addEventListener(type, fn, options);
  return function () {
    return target.removeEventListener(type, fn, options);
  };
}

var DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' + '\r\n' + 'now you can use replayer.getMirror() to access the mirror instance of a replayer,' + '\r\n' + 'or you can use record.mirror to access the mirror instance during recording.';
var _mirror = {
  map: {},
  getId: function getId() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return -1;
  },
  getNode: function getNode() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return null;
  },
  removeNodeFromMap: function removeNodeFromMap() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  },
  has: function has() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return false;
  },
  reset: function reset() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  }
};

if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
  _mirror = new Proxy(_mirror, {
    get: function get(target, prop, receiver) {
      if (prop === 'map') {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
      }

      return Reflect.get(target, prop, receiver);
    }
  });
}

function throttle(func, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout = null;
  var previous = 0;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var now = Date.now();

    if (!previous && options.leading === false) {
      previous = now;
    }

    var remaining = wait - (now - previous);
    var context = this;

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = now;
      func.apply(context, args);
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        func.apply(context, args);
      }, remaining);
    }
  };
}

function hookSetter(target, key, d, isRevoked) {
  var win = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window;
  var original = win.Object.getOwnPropertyDescriptor(target, key);
  win.Object.defineProperty(target, key, isRevoked ? d : {
    set: function set(value) {
      var _this = this;

      setTimeout(function () {
        d.set.call(_this, value);
      }, 0);

      if (original && original.set) {
        original.set.call(this, value);
      }
    }
  });
  return function () {
    return hookSetter(target, key, original || {}, true);
  };
}

function patch(source, name, replacement) {
  try {
    if (!(name in source)) {
      return function () {};
    }

    var original = source[name];
    var wrapped = replacement(original);

    if (typeof wrapped === 'function') {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __rrweb_original__: {
          enumerable: false,
          value: original
        }
      });
    }

    source[name] = wrapped;
    return function () {
      source[name] = original;
    };
  } catch (_a) {
    return function () {};
  }
}

var nowTimestamp = Date.now;

if (!/[1-9][0-9]{12}/.test(Date.now().toString())) {
  nowTimestamp = function nowTimestamp() {
    return new Date().getTime();
  };
}

function getWindowScroll(win) {
  var _a, _b, _c, _d, _e, _f;

  var doc = win.document;
  return {
    left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollLeft) || ((_b = (_a = doc === null || doc === void 0 ? void 0 : doc.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || ((_c = doc === null || doc === void 0 ? void 0 : doc.body) === null || _c === void 0 ? void 0 : _c.scrollLeft) || 0,
    top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) || ((_e = (_d = doc === null || doc === void 0 ? void 0 : doc.body) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.scrollTop) || ((_f = doc === null || doc === void 0 ? void 0 : doc.body) === null || _f === void 0 ? void 0 : _f.scrollTop) || 0
  };
}

function getWindowHeight() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}

function getWindowWidth() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}

function closestElementOfNode(node) {
  if (!node) {
    return null;
  }

  var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
  return el;
}

function isBlocked(node, blockClass, blockSelector, checkAncestors) {
  if (!node) {
    return false;
  }

  var el = closestElementOfNode(node);

  if (!el) {
    return false;
  }

  try {
    if (typeof blockClass === 'string') {
      if (el.classList.contains(blockClass)) return true;
      if (checkAncestors && el.closest('.' + blockClass) !== null) return true;
    } else {
      if (classMatchesRegex(el, blockClass, checkAncestors)) return true;
    }
  } catch (e) {}

  if (blockSelector) {
    if (el.matches(blockSelector)) return true;
    if (checkAncestors && el.closest(blockSelector) !== null) return true;
  }

  return false;
}

function isSerialized(n, mirror) {
  return mirror.getId(n) !== -1;
}

function isIgnored(n, mirror) {
  return mirror.getId(n) === IGNORED_NODE;
}

function isAncestorRemoved(target, mirror) {
  if (isShadowRoot(target)) {
    return false;
  }

  var id = mirror.getId(target);

  if (!mirror.has(id)) {
    return true;
  }

  if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) {
    return false;
  }

  if (!target.parentNode) {
    return true;
  }

  return isAncestorRemoved(target.parentNode, mirror);
}

function legacy_isTouchEvent(event) {
  return Boolean(event.changedTouches);
}

function polyfill() {
  var _this2 = this;

  var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if ('NodeList' in win && !win.NodeList.prototype.forEach) {
    win.NodeList.prototype.forEach = Array.prototype.forEach;
  }

  if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) {
    win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
  }

  if (!Node.prototype.contains) {
    Node.prototype.contains = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var node = args[0];

      if (!(0 in args)) {
        throw new TypeError('1 argument is required');
      }

      do {
        if (_this2 === node) {
          return true;
        }
      } while (node = node && node.parentNode);

      return false;
    };
  }
}

function queueToResolveTrees(queue) {
  var queueNodeMap = {};

  var putIntoMap = function putIntoMap(m, parent) {
    var nodeInTree = {
      value: m,
      parent: parent,
      children: []
    };
    queueNodeMap[m.node.id] = nodeInTree;
    return nodeInTree;
  };

  var queueNodeTrees = [];

  var _iterator = _createForOfIteratorHelper(queue),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var mutation = _step.value;
      var nextId = mutation.nextId,
          parentId = mutation.parentId;

      if (nextId && nextId in queueNodeMap) {
        var nextInTree = queueNodeMap[nextId];

        if (nextInTree.parent) {
          var idx = nextInTree.parent.children.indexOf(nextInTree);
          nextInTree.parent.children.splice(idx, 0, putIntoMap(mutation, nextInTree.parent));
        } else {
          var _idx = queueNodeTrees.indexOf(nextInTree);

          queueNodeTrees.splice(_idx, 0, putIntoMap(mutation, null));
        }

        continue;
      }

      if (parentId in queueNodeMap) {
        var parentInTree = queueNodeMap[parentId];
        parentInTree.children.push(putIntoMap(mutation, parentInTree));
        continue;
      }

      queueNodeTrees.push(putIntoMap(mutation, null));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return queueNodeTrees;
}

function iterateResolveTree(tree, cb) {
  cb(tree.value);

  for (var i = tree.children.length - 1; i >= 0; i--) {
    iterateResolveTree(tree.children[i], cb);
  }
}

function isSerializedIframe(n, mirror) {
  return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}

function isSerializedStylesheet(n, mirror) {
  return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}

function getBaseDimension(node, rootIframe) {
  var _a, _b;

  var frameElement = (_b = (_a = node.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView) === null || _b === void 0 ? void 0 : _b.frameElement;

  if (!frameElement || frameElement === rootIframe) {
    return {
      x: 0,
      y: 0,
      relativeScale: 1,
      absoluteScale: 1
    };
  }

  var frameDimension = frameElement.getBoundingClientRect();
  var frameBaseDimension = getBaseDimension(frameElement, rootIframe);
  var relativeScale = frameDimension.height / frameElement.clientHeight;
  return {
    x: frameDimension.x * frameBaseDimension.relativeScale + frameBaseDimension.x,
    y: frameDimension.y * frameBaseDimension.relativeScale + frameBaseDimension.y,
    relativeScale: relativeScale,
    absoluteScale: frameBaseDimension.absoluteScale * relativeScale
  };
}

function hasShadowRoot(n) {
  return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}

function getNestedRule(rules, position) {
  var rule = rules[position[0]];

  if (position.length === 1) {
    return rule;
  } else {
    return getNestedRule(rule.cssRules[position[1]].cssRules, position.slice(2));
  }
}

function getPositionsAndIndex(nestedIndex) {
  var positions = _toConsumableArray(nestedIndex);

  var index = positions.pop();
  return {
    positions: positions,
    index: index
  };
}

function uniqueTextMutations(mutations) {
  var idSet = new Set();
  var uniqueMutations = [];

  for (var i = mutations.length; i--;) {
    var mutation = mutations[i];

    if (!idSet.has(mutation.id)) {
      uniqueMutations.push(mutation);
      idSet.add(mutation.id);
    }
  }

  return uniqueMutations;
}

var StyleSheetMirror = /*#__PURE__*/function () {
  function StyleSheetMirror() {
    _classCallCheck(this, StyleSheetMirror);

    this.id = 1;
    this.styleIDMap = new WeakMap();
    this.idStyleMap = new Map();
  }

  _createClass(StyleSheetMirror, [{
    key: "getId",
    value: function getId(stylesheet) {
      var _a;

      return (_a = this.styleIDMap.get(stylesheet)) !== null && _a !== void 0 ? _a : -1;
    }
  }, {
    key: "has",
    value: function has(stylesheet) {
      return this.styleIDMap.has(stylesheet);
    }
  }, {
    key: "add",
    value: function add(stylesheet, id) {
      if (this.has(stylesheet)) return this.getId(stylesheet);
      var newId;

      if (id === undefined) {
        newId = this.id++;
      } else newId = id;

      this.styleIDMap.set(stylesheet, newId);
      this.idStyleMap.set(newId, stylesheet);
      return newId;
    }
  }, {
    key: "getStyle",
    value: function getStyle(id) {
      return this.idStyleMap.get(id) || null;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.styleIDMap = new WeakMap();
      this.idStyleMap = new Map();
      this.id = 1;
    }
  }, {
    key: "generateId",
    value: function generateId() {
      return this.id++;
    }
  }]);

  return StyleSheetMirror;
}();

function getShadowHost(n) {
  var _a, _b;

  var shadowHost = null;
  if (((_b = (_a = n.getRootNode) === null || _a === void 0 ? void 0 : _a.call(n)) === null || _b === void 0 ? void 0 : _b.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
  return shadowHost;
}

function getRootShadowHost(n) {
  var rootShadowHost = n;
  var shadowHost;

  while (shadowHost = getShadowHost(rootShadowHost)) {
    rootShadowHost = shadowHost;
  }

  return rootShadowHost;
}

function shadowHostInDom(n) {
  var doc = n.ownerDocument;
  if (!doc) return false;
  var shadowHost = getRootShadowHost(n);
  return doc.contains(shadowHost);
}

function inDom(n) {
  var doc = n.ownerDocument;
  if (!doc) return false;
  return doc.contains(n) || shadowHostInDom(n);
}

export { StyleSheetMirror, _mirror, closestElementOfNode, getBaseDimension, getNestedRule, getPositionsAndIndex, getRootShadowHost, getShadowHost, getWindowHeight, getWindowScroll, getWindowWidth, hasShadowRoot, hookSetter, inDom, isAncestorRemoved, isBlocked, isIgnored, isSerialized, isSerializedIframe, isSerializedStylesheet, iterateResolveTree, legacy_isTouchEvent, nowTimestamp, on, patch, polyfill, queueToResolveTrees, shadowHostInDom, throttle, uniqueTextMutations };